import { JSX } from 'react';
import { GameId, t } from '@bg-shared';
import { GameNavigation } from '@bg-components/GameNavigation';
import { GameNavigationCard } from '@bg-components/GameNavigationCard';
import classNames from 'classnames';
import classes from './LobbyContent.module.scss';
import { LobbyTabId } from '../enums';
import { ILobbyTab } from '../interfaces';

interface ILobbyContentProps {
    activeTabId?: LobbyTabId;
    availableTabs?: ILobbyTab[];
    getGamesByTab?: (tabId: LobbyTabId) => GameId[];
    onCardClick?: () => void;
    header?: string;
    gridClassName?: string;
    cardClassName?: string;
    navigationClassName?: string;
    hwbGames?: GameId[];
}

export const LobbyContent = (props: ILobbyContentProps): JSX.Element => {
    const renderContent = () => {
        const {
            hwbGames,
            activeTabId,
            availableTabs,
            onCardClick,
            getGamesByTab,
            gridClassName,
            cardClassName,
            header,
            navigationClassName,
        } = props;

        const areHwbGamesAvailable = hwbGames?.length > 0;
        const isAllTabActive = activeTabId === LobbyTabId.ALL_CATEGORIES;

        const renderGameCards = (gameIds: GameId[]) => (
            <div className={classNames(classes.grid, gridClassName)} data-qa="area-lobby">
                {gameIds.map((id) => (
                    <GameNavigationCard
                        onClick={onCardClick}
                        className={classNames(classes.cardItem, cardClassName)}
                        key={id}
                        gameId={id}
                    />
                ))}
            </div>
        );

        if (areHwbGamesAvailable) {
            return (
                <div className={classNames(classes.lobbyNavigation, classes.hwbLobby)}>
                    {renderGameCards(hwbGames)}
                </div>
            );
        }

        if (isAllTabActive) {
            return availableTabs.slice(1).map((tab) => (
                <div key={tab.id} className={classes.lobbyNavigation}>
                    <GameNavigation
                        inLobby
                        title={t.gamesCategories(tab.title)}
                        gamesIdsList={getGamesByTab(tab.id)}
                    />
                </div>
            ));
        }

        return (
            <div className={classNames(classes.lobbyNavigation, navigationClassName)}>
                {!!header && (
                    <header className={classes.header}>
                        <strong>{t.gamesCategories(header)}</strong>
                    </header>
                )}
                {renderGameCards(getGamesByTab(activeTabId))}
            </div>
        );
    };

    return <div>{renderContent()}</div>;
};
